import { createReducer } from "typesafe-actions";

import CustomMetric from "@mapmycustomers/shared/types/stackRank/CustomMetric";

import {
  Actions,
  createCustomMetric,
  deleteCustomMetric,
  fetchCustomMetrics,
  updateCustomMetric,
} from "./actions";

export interface StackRankState {
  customMetrics: CustomMetric[];
  deleting: boolean;
  loading: boolean;
  updating: boolean;
}

const initialState: StackRankState = {
  customMetrics: [],
  deleting: false,
  loading: false,
  updating: false,
};

const stackRank = createReducer<StackRankState, Actions>(initialState)
  .handleAction(fetchCustomMetrics.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchCustomMetrics.success, (state, { payload }) => ({
    ...state,
    customMetrics: payload,
    loading: false,
  }))
  .handleAction(fetchCustomMetrics.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction([createCustomMetric.request, updateCustomMetric.request], (state) => ({
    ...state,
    updating: true,
  }))
  .handleAction(createCustomMetric.success, (state, { payload }) => ({
    ...state,
    customMetrics: [...state.customMetrics, payload],
    updating: false,
  }))
  .handleAction(updateCustomMetric.success, (state, { payload }) => ({
    ...state,
    customMetrics: state.customMetrics.map((metric) =>
      metric.id === payload.id ? payload : metric
    ),
    updating: false,
  }))
  .handleAction(deleteCustomMetric.request, (state) => ({
    ...state,
    deleting: true,
  }))
  .handleAction(deleteCustomMetric.success, (state, { payload }) => ({
    ...state,
    customMetrics: state.customMetrics.filter(({ id }) => id !== payload),
    deleting: false,
  }))
  .handleAction(deleteCustomMetric.failure, (state) => ({ ...state, deleting: false }))
  .handleAction([createCustomMetric.failure, updateCustomMetric.failure], (state) => ({
    ...state,
    updating: false,
  }));

export * from "./selectors";

export type StackRankActions = Actions;

export default stackRank;
